import { makeResetMutation } from '@utils/reset-store'
// Mutations
import { STORAGE_KEY_VISAO_GERAL_FILTROS } from '@modules/comissoes/constants/Texts'
import { aawzDate } from '@utils/dates/aawz-date'
import { deepFreeze, freezeItems, upsertFrozenById } from '@utils/Performance'
import { buildInitialState } from './state'

// Helpers best-effort de localStorage: convertem falhas (JSON inválido, Safari privado,
// quota cheia, storage bloqueado) em valor de retorno em vez de propagar a exceção.
const safeJsonParse = (raw) => {
  try {
    return JSON.parse(raw)
  } catch {
    return null
  }
}

const persistToLocalStorage = (key, value) => {
  try {
    globalThis.localStorage.setItem(key, value)
    return true
  } catch {
    return false
  }
}

export const SET_DATA_REFERENCIA = (state, payload) => {
  if (typeof payload !== 'string') {
    return
  }
  const localStorageKey = `comissoes-data-referencia`
  if (payload) {
    state.dataReferencia = payload
    // salvar no localstorage
    window.localStorage.setItem(localStorageKey, payload)
  } else {
    // se nao tiver, busca do localstorage
    const date = window.localStorage.getItem(localStorageKey)
    if (date) {
      state.dataReferencia = date
    }
  }
}
export const SET_SELECTED_FILTERS = (state, payload) => {
  if (payload && typeof payload === 'object') {
    state.selectedFilters = { ...state.selectedFilters, ...payload }
  }
}
export const SET_PROFISSIONAL_FILTRADO = (state, payload) => {
  state.ultimoProfissionalFiltrado = payload

  const localStorageKey = `comissoes-filtro-profissional`
  if (payload) {
    state.ultimoProfissionalFiltrado = payload
    // salvar no localstorage
    window.localStorage.setItem(localStorageKey, payload)
  } else {
    // se nao tiver, busca do localstorage
    const date = window.localStorage.getItem(localStorageKey)
    if (date) {
      state.ultimoProfissionalFiltrado = date
    }
  }
}

export const SET_ADVISOR_COMMISSIONS = (state, payload) => {
  if (payload && typeof payload === 'object') {
    // Tabela grande read-only: congela os itens, mantém o array mutável
    // para o upsert do ADD_* [CU-86ajndcv9]
    state.advisorCommissions.data = freezeItems(payload)
    state.advisorCommissions.lastUpdate = new Date()
  }
}
export const SET_ADVISOR_COMMISSIONS_SUMMARY = (state, payload) => {
  // Replace-total, read-only para display [CU-86ajndcv9]
  state.advisorCommissions.summary = deepFreeze(payload || {})
}
export const SET_ADVISOR_COMMISSIONS_VISIBLE_VALUES = (state, payload) => {
  state.advisorCommissions.visibleValues = payload
}
export const ADD_ADVISOR_COMMISSIONS = (state, payload) => {
  // copy-on-write: substitui o item (frozen) em vez de mutar in-place, para
  // conviver com freezeItems no SET [CU-86ajndcv9]
  upsertFrozenById(state.advisorCommissions.data, payload)
}
export const SET_ADVISOR_COMMISSIONS_LOADING = (state, payload) => {
  state.advisorCommissions.loading = payload
}

// Mutations
export const SET_TAX = (state, payload) => {
  if (payload && typeof payload === 'object') {
    state.tax.data = payload
    state.tax.lastUpdate = new Date()
  }
}
export const ADD_TAX = (state, payload) => {
  if (payload && typeof payload === 'object') {
    let dados = JSON.parse(JSON.stringify(payload))
    if (!Array.isArray(dados)) {
      dados = [dados]
    }
    dados.forEach((data) => {
      let old = state.tax.data.find((item) => item.id === data.id)
      if (old) {
        Object.keys(data).forEach((key) => {
          old[key] = data[key]
        })
      } else {
        state.tax.data.push(data)
      }
    })
  }
}
export const SET_TAX_LOADING = (state, payload) => {
  state.tax.loading = payload
}
export const SET_PAYMENTS = (state, payload) => {
  if (payload && typeof payload === 'object') {
    state.payments.data = payload
    state.payments.lastUpdate = new Date()
  }
}
export const ADD_PAYMENTS = (state, payload) => {
  if (payload && typeof payload === 'object') {
    let dados = JSON.parse(JSON.stringify(payload))
    if (!Array.isArray(dados)) {
      dados = [dados]
    }
    dados.forEach((data) => {
      let old = state.payments.data.find((item) => item.id === data.id)
      if (old) {
        Object.keys(data).forEach((key) => {
          old[key] = data[key]
        })
      } else {
        state.payments.data.push(data)
      }
    })
  }
}
export const SET_PAYMENTS_LOADING = (state, payload) => {
  state.payments.loading = payload
}

// Mutations
export const SET_SPREADS_SHEET = (state, payload) => {
  if (payload && typeof payload === 'object') {
    state.spreadsSheet.data = payload
    state.spreadsSheet.lastUpdate = new Date()
  }
}
export const ADD_SPREADS_SHEET = (state, payload) => {
  if (payload && typeof payload === 'object') {
    let dados = JSON.parse(JSON.stringify(payload))
    if (!Array.isArray(dados)) {
      dados = [dados]
    }
    dados.forEach((data) => {
      let old = state.spreadsSheet.data.find((item) => item.id === data.id)
      if (old) {
        Object.keys(data).forEach((key) => {
          old[key] = data[key]
        })
      } else {
        state.spreadsSheet.data.push(data)
      }
    })
  }
}
export const SET_SPREADS_SHEET_LOADING = (state, payload) => {
  state.spreadsSheet.loading = payload
}

export const SET_BROKERS = (state, payload) => {
  if (payload && typeof payload === 'object') {
    state.brokers.data = payload
    state.brokers.lastUpdate = new Date()
  }
}
export const ADD_BROKERS = (state, payload) => {
  if (payload && typeof payload === 'object') {
    let dados = JSON.parse(JSON.stringify(payload))
    if (!Array.isArray(dados)) {
      dados = [dados]
    }
    dados.forEach((data) => {
      let old = state.brokers.data.find((item) => item.id === data.id)
      if (old) {
        Object.keys(data).forEach((key) => {
          old[key] = data[key]
        })
      } else {
        state.brokers.data.push(data)
      }
    })
  }
}
export const SET_BROKERS_LOADING = (state, payload) => {
  state.brokers.loading = payload
}
export const SET_SHEET_TYPES = (state, payload) => {
  if (payload && typeof payload === 'object') {
    state.sheetTypes.data = payload
    state.sheetTypes.lastUpdate = new Date()
  }
}
export const ADD_SHEET_TYPES = (state, payload) => {
  if (payload && typeof payload === 'object') {
    let dados = JSON.parse(JSON.stringify(payload))
    if (!Array.isArray(dados)) {
      dados = [dados]
    }
    dados.forEach((data) => {
      let old = state.sheetTypes.data.find((item) => item.id === data.id)
      if (old) {
        Object.keys(data).forEach((key) => {
          old[key] = data[key]
        })
      } else {
        state.sheetTypes.data.push(data)
      }
    })
  }
}
export const SET_SHEET_TYPES_LOADING = (state, payload) => {
  state.sheetTypes.loading = payload
}

export const SET_SHEET_MODELS = (state, payload) => {
  if (payload && typeof payload === 'object') {
    state.sheetModels.data = payload
    state.sheetModels.lastUpdate = new Date()
  }
}
export const ADD_SHEET_MODELS = (state, payload) => {
  if (payload && typeof payload === 'object') {
    let dados = JSON.parse(JSON.stringify(payload))
    if (!Array.isArray(dados)) {
      dados = [dados]
    }
    dados.forEach((data) => {
      let old = state.sheetModels.data.find((item) => item.id === data.id)
      if (old) {
        Object.keys(data).forEach((key) => {
          old[key] = data[key]
        })
      } else {
        state.sheetModels.data.push(data)
      }
    })
  }
}
export const SET_SHEET_MODELS_LOADING = (state, payload) => {
  state.sheetModels.loading = payload
}

export const SET_LISTS = (state, { value, audit }) => {
  if (value && typeof value === 'object') {
    state.lists.data = value
    state.lists.audit = audit
    state.lists.lastUpdate = new Date()
  }
}
export const ADD_LISTS = (state, payload) => {
  if (payload && typeof payload === 'object') {
    let dados = JSON.parse(JSON.stringify(payload))
    if (!Array.isArray(dados)) {
      dados = [dados]
    }
    dados.forEach((data) => {
      let old = state.lists.data.find((item) => item.id === data.id)
      if (old) {
        Object.keys(data).forEach((key) => {
          old[key] = data[key]
        })
      } else {
        state.lists.data.push(data)
      }
    })
  }
}
export const SET_LISTS_LOADING = (state, payload) => {
  state.lists.loading = payload
}

export const SET_RULES = (state, payload) => {
  if (payload && typeof payload === 'object') {
    state.rules.data = payload
    state.rules.lastUpdate = new Date()
  }
}
export const ADD_RULES = (state, payload) => {
  if (payload && typeof payload === 'object') {
    let dados = JSON.parse(JSON.stringify(payload))
    if (!Array.isArray(dados)) {
      dados = [dados]
    }
    dados.forEach((data) => {
      let old = state.rules.data.find((item) => item.id === data.id)
      if (old) {
        Object.keys(data).forEach((key) => {
          old[key] = data[key]
        })
      } else {
        state.rules.data.push(data)
      }
    })
  }
}
export const SET_RULES_LOADING = (state, payload) => {
  state.rules.loading = payload
}
export const SET_FECHAMENTOS = (state, payload) => {
  if (payload && typeof payload === 'object') {
    state.fechamentos.data = payload
    state.fechamentos.lastUpdate = new Date()
  }
}
export const ADD_FECHAMENTOS = (state, payload) => {
  if (payload && typeof payload === 'object') {
    let dados = JSON.parse(JSON.stringify(payload))
    if (!Array.isArray(dados)) {
      dados = [dados]
    }
    dados.forEach((data) => {
      let old = state.fechamentos.data.find((item) => item.id === data.id)
      if (old) {
        Object.keys(data).forEach((key) => {
          old[key] = data[key]
        })
      } else {
        state.fechamentos.data.push(data)
      }
    })
  }
}
export const SET_FECHAMENTOS_LOADING = (state, payload) => {
  state.fechamentos.loading = payload
}

export const SET_FILTER_OPTIONS = (state, payload) => {
  if (payload && typeof payload === 'object') {
    state.filterOptions.data = payload
    state.filterOptions.lastUpdate = new Date()
  }
}
export const ADD_FILTER_OPTIONS = (state, payload) => {
  if (payload && typeof payload === 'object') {
    let dados = JSON.parse(JSON.stringify(payload))
    if (!Array.isArray(dados)) {
      dados = [dados]
    }
    dados.forEach((data) => {
      let old = state.filterOptions.data.find((item) => item.id === data.id)
      if (old) {
        Object.keys(data).forEach((key) => {
          old[key] = data[key]
        })
      } else {
        state.filterOptions.data.push(data)
      }
    })
  }
}
export const SET_FILTER_OPTIONS_LOADING = (state, payload) => {
  state.filterOptions.loading = payload
}

export const SET_MINIMO_GARANTIDO = (state, payload) => {
  if (payload && typeof payload === 'object') {
    state.minimoGarantido.data = payload
    state.minimoGarantido.lastUpdate = new Date()
  }
}
export const ADD_MINIMO_GARANTIDO = (state, payload) => {
  if (payload && typeof payload === 'object') {
    let dados = JSON.parse(JSON.stringify(payload))
    if (!Array.isArray(dados)) {
      dados = [dados]
    }
    dados.forEach((data) => {
      let old = state.minimoGarantido.data.find((item) => item.id === data.id)
      if (old) {
        Object.keys(data).forEach((key) => {
          old[key] = data[key]
        })
      } else {
        state.minimoGarantido.data.push(data)
      }
    })
  }
}
export const SET_MINIMO_GARANTIDO_LOADING = (state, payload) => {
  state.minimoGarantido.loading = payload
}

export const SET_MANUAL_ADJUSTMENTS = (state, payload) => {
  if (payload && typeof payload === 'object') {
    state.manualAdjustments.data = payload
    state.manualAdjustments.lastUpdate = new Date()
  }
}
export const ADD_MANUAL_ADJUSTMENTS = (state, payload) => {
  if (payload && typeof payload === 'object') {
    let dados = JSON.parse(JSON.stringify(payload))
    if (!Array.isArray(dados)) {
      dados = [dados]
    }
    dados.forEach((data) => {
      let old = state.manualAdjustments.data.find((item) => item.id === data.id)
      if (old) {
        Object.keys(data).forEach((key) => {
          old[key] = data[key]
        })
      } else {
        state.manualAdjustments.data.push(data)
      }
    })
  }
}
export const SET_MANUAL_ADJUSTMENTS_LOADING = (state, payload) => {
  state.manualAdjustments.loading = payload
}

export const SET_FIELD_CHANGE = (state, payload) => {
  if (payload && typeof payload === 'object') {
    state.fieldChange.data = payload
    state.fieldChange.lastUpdate = new Date()
  }
}
export const ADD_FIELD_CHANGE = (state, payload) => {
  if (payload && typeof payload === 'object') {
    let dados = JSON.parse(JSON.stringify(payload))
    if (!Array.isArray(dados)) {
      dados = [dados]
    }
    dados.forEach((data) => {
      let old = state.fieldChange.data.find((item) => item.id === data.id)
      if (old) {
        Object.keys(data).forEach((key) => {
          old[key] = data[key]
        })
      } else {
        state.fieldChange.data.push(data)
      }
    })
  }
}
export const SET_FIELD_CHANGE_LOADING = (state, payload) => {
  state.fieldChange.loading = payload
}

export const SET_FILTER_OPTIONS_RULES = (state, payload) => {
  if (payload && typeof payload === 'object') {
    state.filterOptionsRules.data = payload
    state.filterOptionsRules.lastUpdate = new Date()
  }
}
export const ADD_FILTER_OPTIONS_RULES = (state, payload) => {
  if (payload && typeof payload === 'object') {
    let dados = JSON.parse(JSON.stringify(payload))
    if (!Array.isArray(dados)) {
      dados = [dados]
    }
    dados.forEach((data) => {
      let old = state.filterOptionsRules.data.find(
        (item) => item.id === data.id
      )
      if (old) {
        Object.keys(data).forEach((key) => {
          old[key] = data[key]
        })
      } else {
        state.filterOptionsRules.data.push(data)
      }
    })
  }
}
export const SET_FILTER_OPTIONS_RULES_LOADING = (state, payload) => {
  state.filterOptionsRules.loading = payload
}

// A guarda é `Array.isArray` — e não `typeof === 'object'` — pela mesma razão
// de `SET_PAYMENT_GROUP_NAMES`: a fatia guarda uma LISTA. Um objeto solto
// virando `data` explode o `[...lista]` de quem ordena as linhas.
//
// `refDate` é zerada no caminho de sucesso de propósito. Gravar a lista carimba
// `lastUpdate` — ou seja, cria cache FRESCO — e quem não declara a competência
// não pode deixar esse cache válido para trás: `SET_PAYMENTS_GROUPS_REF_DATE`,
// comitado na sequência por quem sabe a competência, é o que o revalida.
//
// O caminho de REJEIÇÃO também mexe no cache, e isso não é zelo: o par
// `data`/`refDate` é gravado em dois commits e só este tem guarda. Sair daqui
// em silêncio deixava `data` e `lastUpdate` na competência ANTERIOR, e o
// `SET_PAYMENTS_GROUPS_REF_DATE` logo atrás — que grava sempre — carimbava a
// competência NOVA por cima. O resultado é cache válido para o mês errado: a
// lista de A servida como sucesso para B, a tela assumindo B, e o PUT de lista
// COMPLETA gravando A por cima do mapeamento real de B. Invalidar aqui é o
// único desfecho fail-closed — a carga seguinte volta ao backend.
//
// Precisão: dos dois campos zerados, só `lastUpdate` SOBREVIVE — o
// `SET_PAYMENTS_GROUPS_REF_DATE` recarimba `refDate` um dispatch depois. É o
// `lastUpdate` nulo que mata o cache (`diffTimeMinutes(null, …)` é sempre
// vencido). `refDate = null` fica como defesa em profundidade, para o caso de a
// sequência de dispatch mudar.
//
// ⚠️ Esta guarda hoje é defesa em profundidade, não o portão vivo: desde que a
// API recusa 200 com `value` truthy não-lista (`apiComissoesPaymentsGroups.js`,
// `_traduzirCargaVazia`), o `r.value || []` do único dispatcher sempre entrega
// array. NÃO remova por "código inalcançável" — é o invariante de store que
// impede a próxima porta de entrada de reabrir o bug.
export const SET_PAYMENTS_GROUPS = (state, payload) => {
  if (!Array.isArray(payload)) {
    state.paymentsGroups.lastUpdate = null
    state.paymentsGroups.refDate = null
    return
  }
  state.paymentsGroups.data = payload
  state.paymentsGroups.lastUpdate = new Date()
  state.paymentsGroups.refDate = null
}
export const SET_PAYMENTS_GROUPS_REF_DATE = (state, payload) => {
  state.paymentsGroups.refDate = payload || null
}
export const SET_PAYMENTS_GROUPS_LOADING = (state, payload) => {
  state.paymentsGroups.loading = payload
}

// O payload aqui é uma lista de strings (nomes de Grupo de Pagamento), não a
// lista de objetos de `SET_PAYMENTS_GROUPS`. Por isso a guarda é `Array.isArray`
// e não `typeof === 'object'`: um objeto solto não deve virar `data`.
export const SET_PAYMENT_GROUP_NAMES = (state, payload) => {
  if (Array.isArray(payload)) {
    state.paymentGroupNames.data = payload
    state.paymentGroupNames.lastUpdate = new Date()
  }
}
export const SET_PAYMENT_GROUP_NAMES_LOADING = (state, payload) => {
  state.paymentGroupNames.loading = payload
}

export const SET_APROVACAO_PROFISSIONAL = (state, payload) => {
  if (payload && typeof payload === 'object') {
    state.aprovacaoProfissional.data = payload
    state.aprovacaoProfissional.lastUpdate = new Date()
  }
}
export const ADD_APROVACAO_PROFISSIONAL = (state, payload) => {
  if (payload && typeof payload === 'object') {
    let dados = JSON.parse(JSON.stringify(payload))
    if (!Array.isArray(dados)) {
      dados = [dados]
    }
    dados.forEach((data) => {
      let old = state.aprovacaoProfissional.data.find(
        (item) => item.id === data.id
      )
      if (old) {
        Object.keys(data).forEach((key) => {
          old[key] = data[key]
        })
      } else {
        state.aprovacaoProfissional.data.push(data)
      }
    })
  }
}
export const SET_APROVACAO_PROFISSIONAL_LOADING = (state, payload) => {
  state.aprovacaoProfissional.loading = payload
}

export const SET_SUMMARY_OVERVIEW = (state, payload) => {
  if (payload && typeof payload === 'object') {
    state.summaryOverview.data = freezeItems(payload)
    state.summaryOverview.lastUpdate = new Date()
  }
}
export const ADD_SUMMARY_OVERVIEW = (state, payload) => {
  upsertFrozenById(state.summaryOverview.data, payload)
}
export const SET_SUMMARY_OVERVIEW_LOADING = (state, payload) => {
  state.summaryOverview.loading = payload
}

export const SET_REVENUE_HISTORY = (state, payload) => {
  if (payload && typeof payload === 'object') {
    state.revenueHistory.data = freezeItems(payload)
    state.revenueHistory.lastUpdate = new Date()
  }
}
export const ADD_REVENUE_HISTORY = (state, payload) => {
  upsertFrozenById(state.revenueHistory.data, payload)
}
export const SET_REVENUE_HISTORY_LOADING = (state, payload) => {
  state.revenueHistory.loading = payload
}

export const SET_COMMISSIONS = (state, payload) => {
  if (payload && typeof payload === 'object') {
    state.commissions.data = freezeItems(payload)
    state.commissions.lastUpdate = new Date()
  }
}
export const ADD_COMMISSIONS = (state, payload) => {
  upsertFrozenById(state.commissions.data, payload)
}
export const SET_COMMISSIONS_LOADING = (state, payload) => {
  state.commissions.loading = payload
}

export const SET_COMMISSIONS_DETAILS = (state, payload) => {
  if (payload && typeof payload === 'object') {
    state.commissionsDetails.data = freezeItems(payload)
    state.commissionsDetails.lastUpdate = new Date()
  }
}
export const ADD_COMMISSIONS_DETAILS = (state, payload) => {
  upsertFrozenById(state.commissionsDetails.data, payload)
}
export const SET_COMMISSIONS_DETAILS_LOADING = (state, payload) => {
  state.commissionsDetails.loading = payload
}

export const SET_REVENUE_OVERVIEW = (state, payload) => {
  if (payload && typeof payload === 'object') {
    state.revenueOverview.data = freezeItems(payload)
    state.revenueOverview.lastUpdate = new Date()
  }
}
export const ADD_REVENUE_OVERVIEW = (state, payload) => {
  upsertFrozenById(state.revenueOverview.data, payload)
}
export const SET_REVENUE_OVERVIEW_LOADING = (state, payload) => {
  state.revenueOverview.loading = payload
}

export const SET_REVENUE_OVERVIEW_DETAILS = (state, payload) => {
  if (payload && typeof payload === 'object') {
    state.revenueOverviewDetails.data = freezeItems(payload)
    state.revenueOverviewDetails.lastUpdate = new Date()
  }
}
export const ADD_REVENUE_OVERVIEW_DETAILS = (state, payload) => {
  upsertFrozenById(state.revenueOverviewDetails.data, payload)
}
export const SET_REVENUE_OVERVIEW_DETAILS_LOADING = (state, payload) => {
  state.revenueOverviewDetails.loading = payload
}

export const SET_GENERAL_DATA = (state, payload) => {
  if (payload && typeof payload === 'object') {
    state.generalData.data = freezeItems(payload)
    state.generalData.lastUpdate = new Date()
  }
}
export const ADD_GENERAL_DATA = (state, payload) => {
  upsertFrozenById(state.generalData.data, payload)
}
export const SET_ROA_DATA = (state, payload) => {
  state.roaData.data = payload || { metadata: null, total: null, itens: [] }
  state.roaData.lastUpdate = new Date()
}
export const SET_ROA_DATA_LOADING = (state, payload) => {
  state.roaData.loading = payload
}
export const SET_ROA_COMPETENCIAS = (state, payload) => {
  state.roaCompetencias.data = payload || []
  state.roaCompetencias.lastUpdate = new Date()
}
export const SET_ROA_COMPETENCIAS_LOADING = (state, payload) => {
  state.roaCompetencias.loading = payload
}
export const SET_GENERAL_DATA_LOADING = (state, payload) => {
  state.generalData.loading = payload
}

export const SET_CLIENT_ANALYSIS = (state, payload) => {
  if (payload && typeof payload === 'object') {
    state.clientAnalysis.data = freezeItems(payload)
    state.clientAnalysis.lastUpdate = new Date()
  }
}
export const ADD_CLIENT_ANALYSIS = (state, payload) => {
  upsertFrozenById(state.clientAnalysis.data, payload)
}
export const SET_CLIENT_ANALYSIS_LOADING = (state, payload) => {
  state.clientAnalysis.loading = payload
}

export const SET_RESULTS_BY_ADVISOR = (state, payload) => {
  if (payload && typeof payload === 'object') {
    state.resultsByAdvisor.data = freezeItems(payload)
    state.resultsByAdvisor.lastUpdate = new Date()
  }
}
export const ADD_RESULTS_BY_ADVISOR = (state, payload) => {
  upsertFrozenById(state.resultsByAdvisor.data, payload)
}
export const SET_RESULTS_BY_ADVISOR_LOADING = (state, payload) => {
  state.resultsByAdvisor.loading = payload
}

export const SET_RESULTS_BY_CATEGORIES = (state, payload) => {
  if (payload && typeof payload === 'object') {
    state.resultsByCategories.data = freezeItems(payload)
    state.resultsByCategories.lastUpdate = new Date()
  }
}
export const ADD_RESULTS_BY_CATEGORIES = (state, payload) => {
  upsertFrozenById(state.resultsByCategories.data, payload)
}
export const SET_RESULTS_BY_CATEGORIES_LOADING = (state, payload) => {
  state.resultsByCategories.loading = payload
}

export const SET_COMENTARIOS = (state, payload) => {
  if (payload && typeof payload === 'object') {
    state.comentarios.data = payload
    state.comentarios.lastUpdate = new Date()
  }
}
export const ADD_COMENTARIOS = (state, payload) => {
  if (payload && typeof payload === 'object') {
    let dados = JSON.parse(JSON.stringify(payload))
    if (!Array.isArray(dados)) {
      dados = [dados]
    }
    dados.forEach((data) => {
      let old = state.comentarios.data.find((item) => item.id === data.id)
      if (old) {
        Object.keys(data).forEach((key) => {
          old[key] = data[key]
        })
      } else {
        state.comentarios.data.push(data)
      }
    })
  }
}
export const SET_COMENTARIOS_LOADING = (state, payload) => {
  state.comentarios.loading = payload
}

export const SET_EXPORT_PAYMENTS = (state, payload) => {
  if (payload && typeof payload === 'object') {
    state.exportPayments.data = payload
    state.exportPayments.lastUpdate = new Date()
  }
}
export const ADD_EXPORT_PAYMENTS = (state, payload) => {
  if (payload && typeof payload === 'object') {
    let dados = JSON.parse(JSON.stringify(payload))
    if (!Array.isArray(dados)) {
      dados = [dados]
    }
    dados.forEach((data) => {
      let old = state.exportPayments.data.find((item) => item.id === data.id)
      if (old) {
        Object.keys(data).forEach((key) => {
          old[key] = data[key]
        })
      } else {
        state.exportPayments.data.push(data)
      }
    })
  }
}
export const SET_EXPORT_PAYMENTS_LOADING = (state, payload) => {
  state.exportPayments.loading = payload
}
export const SET_DADOS_INDICADORES = (state, payload) => {
  if (payload && typeof payload === 'object') {
    // Dados de gráfico/relatório, replace-total read-only [CU-86ajndcv9]
    state.dadosIndicadores.data = deepFreeze(payload)
    state.dadosIndicadores.lastUpdate = new Date()
  }
}
export const SET_DADOS_INDICADORES_LOADING = (state, payload) => {
  state.dadosIndicadores.loading = payload
}

export const SET_DADOS_PROFISSIONAIS = (state, payload) => {
  if (payload && typeof payload === 'object') {
    // Dados de gráfico/relatório, replace-total read-only [CU-86ajndcv9]
    state.dadosProfissionais.data = deepFreeze(payload)
    state.dadosProfissionais.lastUpdate = new Date()
  }
}
export const SET_DADOS_PROFISSIONAIS_LOADING = (state, payload) => {
  state.dadosProfissionais.loading = payload
}

export const SET_DADOS_CATEGORIAS = (state, payload) => {
  if (payload && typeof payload === 'object') {
    // Dados de gráfico/relatório, replace-total read-only [CU-86ajndcv9]
    state.dadosCategorias.data = deepFreeze(payload)
    state.dadosCategorias.lastUpdate = new Date()
  }
}
export const SET_DADOS_CATEGORIAS_LOADING = (state, payload) => {
  state.dadosCategorias.loading = payload
}

export const SET_REFERENCE_BASE = (state, payload) => {
  if (payload && typeof payload === 'object') {
    state.referenceBase.data = payload
    state.referenceBase.lastUpdate = new Date()
  }
}
export const ADD_REFERENCE_BASE = (state, payload) => {
  if (payload && typeof payload === 'object') {
    let dados = JSON.parse(JSON.stringify(payload))
    if (!Array.isArray(dados)) {
      dados = [dados]
    }
    dados.forEach((data) => {
      let old = state.referenceBase.data.find((item) => item.id === data.id)
      if (old) {
        Object.keys(data).forEach((key) => {
          old[key] = data[key]
        })
      } else {
        state.referenceBase.data.push(data)
      }
    })
  }
}
export const SET_REFERENCE_BASE_LOADING = (state, payload) => {
  state.referenceBase.loading = payload
}

export const SET_LOCAL_FILTERS = (state, payload = {}) => {
  const { filters = {}, idEscritorio = null } = payload

  const newFilters = {
    ...state.localFilters.data,
    ...filters,
  }

  state.localFilters.data = newFilters

  // Persistência best-effort: o state já foi atualizado acima. Gravar no localStorage
  // não pode derrubar a aplicação dos filtros — em Safari privado, quota cheia ou storage
  // bloqueado o setItem lança (QuotaExceededError/SecurityError) e o SET roda no caminho
  // crítico de applyFilters() na view-overview.
  // idEscritorio carimba a qual escritório os filtros pertencem: o storage é por navegador
  // e o admin interno alterna escritórios — sem o carimbo os filtros vazariam entre eles.
  const now = aawzDate()
  const filterData = {
    filters: newFilters,
    month: now.month(),
    year: now.year(),
    idEscritorio,
  }

  persistToLocalStorage(
    STORAGE_KEY_VISAO_GERAL_FILTROS,
    JSON.stringify(filterData)
  )
}

export const LOAD_LOCAL_FILTERS_FROM_STORAGE = (
  state,
  idEscritorioAtual = null
) => {
  const stored = globalThis.localStorage.getItem(STORAGE_KEY_VISAO_GERAL_FILTROS)

  if (!stored) {
    return
  }

  const filterData = safeJsonParse(stored)
  const now = aawzDate()
  const isSameMonth =
    filterData &&
    filterData.month === now.month() &&
    filterData.year === now.year()
  // Só restaura se os filtros foram salvos no MESMO escritório em visualização agora.
  // Caso contrário (admin interno trocou de escritório, ou dado legado sem carimbo),
  // descarta para não aplicar IDs de profissional/cliente/etc de outro escritório.
  const isSameOffice =
    filterData && filterData.idEscritorio === idEscritorioAtual

  if (isSameMonth && isSameOffice) {
    // Mesmo mês e mesmo escritório — carregar os filtros salvos
    state.localFilters.data = {
      ...state.localFilters.data,
      ...filterData.filters,
    }
  } else {
    // Novo mês, escritório diferente ou dado inválido — limpar o localStorage
    globalThis.localStorage.removeItem(STORAGE_KEY_VISAO_GERAL_FILTROS)
  }
}
export const SET_BASE_CLIENTES = (state, payload) => {
  if (payload && typeof payload === 'object') {
    state.baseClientes.data = payload
    state.baseClientes.lastUpdate = new Date()
  }
}
export const ADD_BASE_CLIENTES = (state, payload) => {
  if (payload && typeof payload === 'object') {
    let dados = JSON.parse(JSON.stringify(payload))
    if (!Array.isArray(dados)) {
      dados = [dados]
    }
    dados.forEach((data) => {
      let old = state.baseClientes.data.find((item) => item.id === data.id)
      if (old) {
        Object.keys(data).forEach((key) => {
          old[key] = data[key]
        })
      } else {
        state.baseClientes.data.push(data)
      }
    })
  }
}
export const REMOVE_CLIENT = (state, payload) => {
  if (payload) {
    const { id } = payload
    state.baseClientes.data = state.baseClientes.data.filter(
      (item) => item.id !== id
    )
  }
}
export const SET_BASE_CLIENTES_LOADING = (state, payload) => {
  state.baseClientes.loading = payload
}
export const SET_GATILHOS_PERFORMANCE = (state, payload) => {
  if (payload && typeof payload === 'object') {
    state.gatilhosPerformance.data = { ...payload }
    state.gatilhosPerformance.lastUpdate = new Date()
  } else {
    state.gatilhosPerformance.data = {}
  }
}
export const ADD_GATILHOS_PERFORMANCE = (state, payload) => {
  if (payload && typeof payload === 'object') {
    state.gatilhosPerformance.data = {
      ...state.gatilhosPerformance.data,
      ...payload,
    }
    state.gatilhosPerformance.lastUpdate = new Date()
  }
}
export const SET_GATILHOS_PERFORMANCE_LOADING = (state, payload) => {
  state.gatilhosPerformance.loading = payload
}
export const SET_GATILHOS_INDICADORES = (state, payload) => {
  if (payload && typeof payload === 'object') {
    state.gatilhosIndicadores.data = payload
    state.gatilhosIndicadores.lastUpdate = new Date()
  }
}
export const SET_GATILHOS_INDICADORES_RESULTADOS = (state, payload) => {
  state.gatilhosIndicadores.resultados = Array.isArray(payload) ? payload : []
}
export const ADD_GATILHOS_INDICADORES = (state, payload) => {
  if (payload && typeof payload === 'object') {
    let dados = JSON.parse(JSON.stringify(payload))
    if (!Array.isArray(dados)) {
      dados = [dados]
    }
    dados.forEach((data) => {
      let old = state.gatilhosIndicadores.data.find(
        (item) => item.id === data.id
      )
      if (old) {
        Object.keys(data).forEach((key) => {
          old[key] = data[key]
        })
      } else {
        state.gatilhosIndicadores.data.push(data)
      }
    })
  }
}
export const REMOVE_GATILHOS_INDICADORES = (state, payload) => {
  if (payload) {
    const { id } = payload
    state.gatilhosIndicadores.data = state.gatilhosIndicadores.data.filter(
      (item) => item.id !== id
    )
  }
}
export const SET_GATILHOS_INDICADORES_LOADING = (state, payload) => {
  state.gatilhosIndicadores.loading = payload
}

// RESET: restaura o state inicial (libera dados de cliente/escritório retidos
// entre trocas de perfil/escritório in-SPA). Reatribui cada chave a partir do
// factory — reusa a reatividade existente. [CU-86ajnmt4r]
export const RESET = makeResetMutation(buildInitialState)
